'use client';

import React, { useState, useEffect } from 'react';
import DashboardStats from './DashboardStats';
import UpcomingEvents from './UpcomingEvents';
import HandicapTracker from './HandicapTracker';
import Leaderboard from './Leaderboard';
import RecentActivity from './RecentActivity';
import MemberDirectory from './MemberDirectory';
import Achievements from './Achievements';
import QuickActions from './QuickActions';

const MembersDashboardInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const dashboardStats = [
  {
    icon: 'ChartBarIcon',
    label: 'Current Handicap',
    value: '12.4',
    trend: { value: '2.1 improvement', isPositive: true },
    bgColor: 'bg-card'
  },
  {
    icon: 'CalendarIcon',
    label: 'Events This Month',
    value: 5,
    trend: { value: '2 more than last month', isPositive: true },
    bgColor: 'bg-card'
  },
  {
    icon: 'TrophyIcon',
    label: 'Tournaments Won',
    value: 3,
    bgColor: 'bg-card'
  },
  {
    icon: 'UserGroupIcon',
    label: 'Society Members',
    value: 247,
    trend: { value: '12 new this month', isPositive: true },
    bgColor: 'bg-card'
  }];


  const upcomingEvents = [
  {
    id: 1,
    title: 'Spring Championship',
    date: 'March 15, 2026',
    time: '8:00 AM',
    course: 'Royal Birkdale Golf Club',
    courseImage: "https://images.unsplash.com/photo-1621362802997-0fd375c0d106",
    courseImageAlt: 'Aerial view of Royal Birkdale Golf Club championship links course with sand dunes',
    spotsLeft: 8,
    totalSpots: 40,
    registered: true
  },
  {
    id: 2,
    title: 'Monthly Medal Round',
    date: 'March 22, 2026',
    time: '9:30 AM',
    course: 'Wentworth Club',
    courseImage: "https://images.unsplash.com/photo-1531126015916-4d3c6313fb05",
    courseImageAlt: 'Pristine Wentworth Club golf course with manicured fairway and mature trees',
    spotsLeft: 15,
    totalSpots: 32,
    registered: false
  },
  {
    id: 3,
    title: 'Sunset Social Round',
    date: 'March 28, 2026',
    time: '4:00 PM',
    course: 'St Andrews Old Course',
    courseImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1b7edcc-1765884714753.png",
    courseImageAlt: 'Historic St Andrews Old Course with iconic stone bridge and rolling Scottish landscape',
    spotsLeft: 4,
    totalSpots: 24,
    registered: false
  }];


  const handicapData = [
  { date: 'Jan', handicap: 15.2 },
  { date: 'Feb', handicap: 14.8 },
  { date: 'Mar', handicap: 14.1 },
  { date: 'Apr', handicap: 13.5 },
  { date: 'May', handicap: 13.2 },
  { date: 'Jun', handicap: 12.9 },
  { date: 'Jul', handicap: 12.4 }];


  const leaderboardEntries = [
  {
    rank: 1,
    name: 'James Mitchell',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_116ebc879-1763295731902.png",
    avatarAlt: 'Professional headshot of James Mitchell, Caucasian man with short brown hair in navy blazer',
    handicap: 8.2,
    change: -1.5,
    rounds: 24
  },
  {
    rank: 2,
    name: 'Sarah Thompson',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    avatarAlt: 'Professional headshot of Sarah Thompson, woman with long brown hair in white blouse',
    handicap: 9.1,
    change: -0.8,
    rounds: 22
  },
  {
    rank: 3,
    name: 'Robert Chen',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13a48293d-1763296098326.png",
    avatarAlt: 'Professional headshot of Robert Chen, Asian man with black hair in gray suit',
    handicap: 9.7,
    change: -1.2,
    rounds: 26
  },
  {
    rank: 4,
    name: 'Emily Rodriguez',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18d0c753c-1763295606875.png",
    avatarAlt: 'Professional headshot of Emily Rodriguez, Hispanic woman with dark hair in blue blazer',
    handicap: 10.3,
    change: 0.5,
    rounds: 20
  },
  {
    rank: 5,
    name: 'Michael OConnor',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_171f990ec-1763294194198.png",
    avatarAlt: 'Professional headshot of Michael OConnor, man with beard in casual shirt outdoors',
    handicap: 10.8,
    change: -0.3,
    rounds: 19
  }];


  const recentActivities = [
  {
    id: 1,
    type: 'score' as const,
    user: 'James Mitchell',
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_116ebc879-1763295731902.png",
    userAvatarAlt: 'Professional headshot of James Mitchell, Caucasian man with short brown hair in navy blazer',
    action: 'posted a new score',
    details: 'Shot 72 at Pebble Beach Golf Links',
    timestamp: '2 hours ago',
    icon: 'ChartBarIcon'
  },
  {
    id: 2,
    type: 'achievement' as const,
    user: 'Sarah Thompson',
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    userAvatarAlt: 'Professional headshot of Sarah Thompson, woman with long brown hair in white blouse',
    action: 'earned an achievement',
    details: 'Completed 20 rounds milestone',
    timestamp: '5 hours ago',
    icon: 'TrophyIcon'
  },
  {
    id: 3,
    type: 'event' as const,
    user: 'Robert Chen',
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13a48293d-1763296098326.png",
    userAvatarAlt: 'Professional headshot of Robert Chen, Asian man with black hair in gray suit',
    action: 'registered for',
    details: 'Spring Championship at Pebble Beach',
    timestamp: '1 day ago',
    icon: 'CalendarIcon'
  },
  {
    id: 4,
    type: 'social' as const,
    user: 'Emily Rodriguez',
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18d0c753c-1763295606875.png",
    userAvatarAlt: 'Professional headshot of Emily Rodriguez, Hispanic woman with dark hair in blue blazer',
    action: 'shared a course review',
    details: 'Reviewed Augusta National Golf Club - 5 stars',
    timestamp: '2 days ago',
    icon: 'StarIcon'
  },
  {
    id: 5,
    type: 'score' as const,
    user: 'Michael OConnor',
    userAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_171f990ec-1763294194198.png",
    userAvatarAlt: 'Professional headshot of Michael OConnor, man with beard in casual shirt outdoors',
    action: 'improved handicap',
    details: 'Handicap decreased from 11.2 to 10.8',
    timestamp: '3 days ago',
    icon: 'ArrowTrendingDownIcon'
  }];


  const members = [
  {
    id: 1,
    name: 'James Mitchell',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_116ebc879-1763295731902.png",
    avatarAlt: 'Professional headshot of James Mitchell, Caucasian man with short brown hair in navy blazer',
    handicap: 8.2,
    location: 'San Francisco, CA',
    memberSince: '2022',
    interests: ['Tournament Play', 'Course Reviews', 'Equipment']
  },
  {
    id: 2,
    name: 'Sarah Thompson',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
    avatarAlt: 'Professional headshot of Sarah Thompson, woman with long brown hair in white blouse',
    handicap: 9.1,
    location: 'Los Angeles, CA',
    memberSince: '2023',
    interests: ['Social Golf', 'Networking', 'Travel']
  },
  {
    id: 3,
    name: 'Robert Chen',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13a48293d-1763296098326.png",
    avatarAlt: 'Professional headshot of Robert Chen, Asian man with black hair in gray suit',
    handicap: 9.7,
    location: 'Seattle, WA',
    memberSince: '2021',
    interests: ['Competitive Play', 'Coaching', 'Statistics']
  },
  {
    id: 4,
    name: 'Emily Rodriguez',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18d0c753c-1763295606875.png",
    avatarAlt: 'Professional headshot of Emily Rodriguez, Hispanic woman with dark hair in blue blazer',
    handicap: 10.3,
    location: 'Austin, TX',
    memberSince: '2023',
    interests: ['Social Events', 'Photography', 'Fitness']
  },
  {
    id: 5,
    name: 'Michael OConnor',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_171f990ec-1763294194198.png",
    avatarAlt: 'Professional headshot of Michael OConnor, man with beard in casual shirt outdoors',
    handicap: 10.8,
    location: 'Boston, MA',
    memberSince: '2022',
    interests: ['Course Design', 'History', 'Teaching']
  },
  {
    id: 6,
    name: 'Jennifer Park',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1067fedfa-1763295767794.png",
    avatarAlt: 'Professional headshot of Jennifer Park, Asian woman with long black hair in professional attire',
    handicap: 11.5,
    location: 'Portland, OR',
    memberSince: '2024',
    interests: ['Beginner Friendly', 'Wellness', 'Community']
  }];


  const achievements = [
  {
    id: 1,
    title: 'First Round',
    description: 'Complete your first round',
    icon: 'FlagIcon',
    earned: true,
    earnedDate: 'Jan 15, 2024'
  },
  {
    id: 2,
    title: 'Eagle Eye',
    description: 'Score an eagle',
    icon: 'EyeIcon',
    earned: true,
    earnedDate: 'Feb 22, 2024'
  },
  {
    id: 3,
    title: 'Social Butterfly',
    description: 'Connect with 10 members',
    icon: 'UserGroupIcon',
    earned: true,
    earnedDate: 'Mar 10, 2024'
  },
  {
    id: 4,
    title: 'Course Explorer',
    description: 'Play 10 different courses',
    icon: 'MapIcon',
    earned: false,
    progress: 7,
    total: 10
  },
  {
    id: 5,
    title: 'Tournament Victor',
    description: 'Win a tournament',
    icon: 'TrophyIcon',
    earned: false,
    progress: 0,
    total: 1
  },
  {
    id: 6,
    title: 'Handicap Hero',
    description: 'Improve handicap by 5 points',
    icon: 'ArrowTrendingDownIcon',
    earned: false,
    progress: 2.8,
    total: 5
  }];


  const quickActions = [
  {
    id: 1,
    title: 'Register for Event',
    description: 'Sign up for upcoming fixtures',
    icon: 'CalendarIcon',
    href: '/fixtures',
    color: 'bg-primary'
  },
  {
    id: 2,
    title: 'Submit Score',
    description: 'Record your latest round',
    icon: 'PencilSquareIcon',
    href: '/members-dashboard',
    color: 'bg-secondary'
  },
  {
    id: 3,
    title: 'Write Review',
    description: 'Share your course experience',
    icon: 'StarIcon',
    href: '/course-reviews',
    color: 'bg-accent'
  },
  {
    id: 4,
    title: 'View Leaderboard',
    description: 'Check your ranking',
    icon: 'TrophyIcon',
    href: '/members-dashboard',
    color: 'bg-cta'
  },
  {
    id: 5,
    title: 'Browse Articles',
    description: 'Read golf tips and stories',
    icon: 'DocumentTextIcon',
    href: '/articles',
    color: 'bg-trust-builder'
  },
  {
    id: 6,
    title: 'Update Profile',
    description: 'Manage your information',
    icon: 'UserCircleIcon',
    href: '/members-dashboard',
    color: 'bg-conversion-accent'
  }];


  if (!isHydrated) {
    return (
      <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:375:6" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="375" data-component-end-line="390" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20pt-24%20pb-16%20px-4%22%7D" className="min-h-screen bg-background pt-24 pb-16 px-4">
        <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:376:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="376" data-component-end-line="389" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%22%7D" className="max-w-7xl mx-auto">
          <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:377:10" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="377" data-component-end-line="388" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-pulse%20space-y-8%22%7D" className="animate-pulse space-y-8">
            <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:378:12" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="378" data-component-end-line="378" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-12%20bg-muted%20rounded%20w-1%2F3%22%7D" className="h-12 bg-muted rounded w-1/3"></div>
            <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:379:12" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="379" data-component-end-line="383" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[1, 2, 3, 4].map((i) =>
              <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:381:14" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="381" data-component-end-line="381" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-32%20bg-muted%20rounded-lg%22%7D" key={i} className="h-32 bg-muted rounded-lg"></div>
              )}
            </div>
            <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:384:12" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="384" data-component-end-line="387" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-2%20gap-8%22%7D" className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:385:14" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="385" data-component-end-line="385" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-muted%20rounded-lg%22%7D" className="h-96 bg-muted rounded-lg"></div>
              <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:386:14" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="386" data-component-end-line="386" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-96%20bg-muted%20rounded-lg%22%7D" className="h-96 bg-muted rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>);

  }

  return (
    <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:395:4" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="395" data-component-end-line="437" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%20pt-20%20pb-12%20px-3%20sm%3Apx-4%22%7D" className="min-h-screen bg-background pt-20 pb-12 px-3 sm:px-4">
      <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:396:6" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="396" data-component-end-line="436" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20space-y-6%22%7D" className="max-w-7xl mx-auto space-y-6">
        {/* Welcome Section */}
        <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:398:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="398" data-component-end-line="403" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20sm%3Aflex-row%20sm%3Aitems-center%20sm%3Ajustify-between%20gap-3%22%7D" className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:399:10" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="399" data-component-end-line="402" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
            <h1 data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:400:12" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="400" data-component-end-line="400" data-component-file="MembersDashboardInteractive.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22text-2xl%20sm%3Atext-3xl%20lg%3Atext-4xl%20font-heading%20font-bold%20text-foreground%20mb-1%22%2C%22textContent%22%3A%22Welcome%20back%2C%20John!%22%7D" className="text-2xl sm:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-1">Welcome back, John!</h1>
            <p data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:401:12" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="401" data-component-end-line="401" data-component-file="MembersDashboardInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20sm%3Atext-lg%20font-body%20text-muted-foreground%22%2C%22textContent%22%3A%22Here's%20your%20golf%20activity%20overview%22%7D" className="text-base sm:text-lg font-body text-muted-foreground">Here's your golf activity overview</p>
          </div>
        </div>

        {/* Dashboard Stats */}
        <DashboardStats data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:406:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="406" data-component-end-line="406" data-component-file="MembersDashboardInteractive.tsx" data-component-name="DashboardStats" data-component-content="%7B%22elementName%22%3A%22DashboardStats%22%7D" stats={dashboardStats} />

        {/* Quick Actions */}
        <QuickActions data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:409:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="409" data-component-end-line="409" data-component-file="MembersDashboardInteractive.tsx" data-component-name="QuickActions" data-component-content="%7B%22elementName%22%3A%22QuickActions%22%7D" actions={quickActions} />

        {/* Main Content Grid */}
        <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:412:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="412" data-component-end-line="423" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-2%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Upcoming Events */}
          <UpcomingEvents data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:414:10" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="414" data-component-end-line="414" data-component-file="MembersDashboardInteractive.tsx" data-component-name="UpcomingEvents" data-component-content="%7B%22elementName%22%3A%22UpcomingEvents%22%7D" events={upcomingEvents} />

          {/* Handicap Tracker */}
          <HandicapTracker data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:417:10" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="417" data-component-end-line="421" data-component-file="MembersDashboardInteractive.tsx" data-component-name="HandicapTracker" data-component-content="%7B%22elementName%22%3A%22HandicapTracker%22%7D"
            currentHandicap={12.4}
            trend="2.1 improvement"
            isImproving={true}
            data={handicapData} />

        </div>

        {/* Leaderboard and Activity */}
        <div data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:426:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="426" data-component-end-line="429" data-component-file="MembersDashboardInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-2%20gap-6%22%7D" className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Leaderboard data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:427:10" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="427" data-component-end-line="427" data-component-file="MembersDashboardInteractive.tsx" data-component-name="Leaderboard" data-component-content="%7B%22elementName%22%3A%22Leaderboard%22%7D" entries={leaderboardEntries} category="Overall Rankings" />
          <RecentActivity data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:428:10" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="428" data-component-end-line="428" data-component-file="MembersDashboardInteractive.tsx" data-component-name="RecentActivity" data-component-content="%7B%22elementName%22%3A%22RecentActivity%22%7D" activities={recentActivities} />
        </div>

        {/* Achievements */}
        <Achievements data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:432:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="432" data-component-end-line="432" data-component-file="MembersDashboardInteractive.tsx" data-component-name="Achievements" data-component-content="%7B%22elementName%22%3A%22Achievements%22%7D" achievements={achievements} />

        {/* Member Directory */}
        <MemberDirectory data-component-id="src/app/members-dashboard/components/MembersDashboardInteractive.tsx:435:8" data-component-path="src/app/members-dashboard/components/MembersDashboardInteractive.tsx" data-component-line="435" data-component-end-line="435" data-component-file="MembersDashboardInteractive.tsx" data-component-name="MemberDirectory" data-component-content="%7B%22elementName%22%3A%22MemberDirectory%22%7D" members={members} />
      </div>
    </div>);

};

export default MembersDashboardInteractive;